import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_Fund = forwardRef((props, ref) => {

    const toaster = rsuite.useToaster();

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(General.GuidEmpty());
    const Fund_Onchange = (value) => {
        props.onChange(value == null ? General.GuidEmpty() : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({
        Bind(id) {
            var isDefault = 0;

            trackPromise(
                fetch(General.ApiRoute() + '/Fund/GetAll', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey(),
                        'IsActive': 1
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        var temp = [];
                        for (let index = 0; index < result.length; index++) {
                            temp.push({
                                Id: result[index].id,
                                Title: result[index].title + " [" + result[index].code + "]",
                            })
                            if ((result[index].isDefault == 1 && id == General.GuidEmpty()) || result[index].id == id) {
                                props.onChange(result[index].id, result[index].title + " [" + result[index].code + "]")
                                setId(result[index].id)
                                isDefault=1

                            }
                            else if(isDefault==0)
                                setId(id);
                        }

                        setList(temp);
                    })
            )

        },

    }))



    return (
        <rsuite.SelectPicker


            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => Fund_Onchange(value)}



        />


    )
});

export default Drp_Fund;